import React from "react";
import { styled, TextField, TextFieldProps } from "@mui/material";

export default styled((props: TextFieldProps) => {
  return (
    <TextField
      {...props}
      variant="standard"
      InputLabelProps={{
        color: "secondary",
        disableAnimation: true,
        shrink: true,
      }}
    />
  );
})({
  borderRadius: "2px",
  fontWeight: 400,
  "& .MuiInput-input": {
    padding: 10,
  },
  "& .MuiInputBase-root": {
    height: "100%",
  },
});
